import styled from "@emotion/styled";
import {Box} from "@mediaspace/shared/styled";
import {Button} from "@kaltura/ds-react-components";

export const StyledContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
        width: "auto"
    }
}));

export const StyledButton = styled(Button)({
    minWidth: 0,
    maxWidth: "fit-content",
    padding: 0,
    "&:hover": {
        backgroundColor: "transparent"
    }
}) as unknown as typeof Button;
